export const MAGIC_INSIGHTS_CREDITS_FEATURE_NAME = 'Magic Insights Credits';

export interface CombinedQuotaBalance {
  assigned: number;
  usage: number;
  remaining: number;
}
